import styled, { css } from 'styled-components';

export const Container = styled.div`
  max-width: 980px;
  display: flex;
  gap: 44px;
  align-items: flex-start;
  position: relative;

  @media only screen and (min-width: 950px) {
    width: 980px;
  }

  @media only screen and (max-width: 950px) {
    align-items: center;
    justify-content: center;
    width: 100%;
    /* width: 980px; */
  }

  h2 {
    position: absolute;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 300px;
    color: #667085;
    top: -134px;
    left: -50px;
    z-index: 1;
    @media only screen and (max-width: 950px) {
      display: none;
    }
  }

  div.container-slider {
    position: relative;
    transition: 0.6s;
    width: 100%;
    overflow: hidden;

    @media only screen and (max-width: 950px) {
      justify-content: center;
    }

    div.inner-slider {
      pointer-events: none;
      width: 100%;
      display: flex;
      gap: 44px;
      transition: 0.6s;
      position: absolute;
      left: 0;

      @media only screen and (max-width: 950px) {
        left: 12px;
      }
    }
  }
`;

export const Main = styled.div`
  width: 100%;
  display: ${props => (props.actived ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 108px;
  margin-bottom: 68px;
  position: relative;
`;

export const Card = styled.div`
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px;
  gap: 32px;
  width: 100%;
  min-width: 465px;
  min-height: 356px;
  background: #ffffff;
  border-radius: 6px;

  @media only screen and (max-width: 950px) {
    min-width: 365px;
  }

  h4 {
    font-style: italic;
    font-weight: 400;
    font-size: 24px;
    line-height: 30px;
    color: #475467;

    @media only screen and (max-width: 950px) {
      font-weight: 300;
      font-size: 18px;
      line-height: 23px;
      text-align: center;
    }
  }

  div.container-avatar {
    display: flex;
    align-items: center;
    gap: 32px;

    @media only screen and (max-width: 950px) {
      gap: 22px;
    }

    div.container-name-post {
      display: flex;
      flex-direction: column;
      gap: 4px;

      h6 {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        text-transform: uppercase;
        color: #475467;

        @media only screen and (max-width: 950px) {
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 18px;
          width: 165px;
          text-align: start;
        }
      }
    }
  }

  @media only screen and (max-width: 950px) {
    width: 311px;
  }
`;

export const Row = styled.div`
  margin-top: 40px;

  ${props =>
    props.hide &&
    css`
      display: none;
    `}

  svg {
    margin-left: 8px;
    width: 10px;
  }
  @media only screen and (max-width: 950px) {
    width: 100%;
    display: flex;
    ${props =>
      props.total <= 1 &&
      css`
        display: none;
      `}

    align-items: center;
    justify-content: center;

    svg {
      margin-left: 8px;
      width: 8px;
    }
  }
`;
